<template>
    <div>
      <div class="container-fluid right_wrapper">
        <AddVendorHeader></AddVendorHeader>
        <AddVendorForm3 class="table_wrap no_footer pt-2"></AddVendorForm3>
      </div>
    </div>
</template>

<script>
import AddVendorHeader from '@/components/account-management/AddVendorHeader.vue'
import AddVendorForm3 from '@/components/account-management/AddVendorForm3.vue'

export default {
    components: {
        AddVendorHeader,
		AddVendorForm3
    }
}
</script>

<style lang="scss">

</style>
